import Services from '../Service'

class AuthService extends Services {
  constructor() {
    super()
    this.resource = 'auth'
  }

  async login(credentials) {
    return await this.postAPI(this.resource + '/login', credentials)
  }

  async logout() {
    return await this.postAPI(this.resource + '/logout')
  }
}

export default new AuthService()